






















































































import * as _ from 'lodash';
import { Component, Vue, Watch } from 'vue-property-decorator';
import { ITemplate, ITemplateUpdate } from '@/interfaces';
import {
  dispatchGetContracts,
  dispatchGetServices,
  dispatchGetTemplate,
  dispatchUpdateTemplate,
  dispatchParseMessage,
  dispatchGetSenders,
  dispatchGetPriorities,
  readOneTemplate,
  readContracts,
  readPriorities,
  dispatchGetMNOs,
  dispatchSuggestTags,
  readMNOs,
} from '@/store/admin/accessors';
import VTextAreaWithValidation from '@/components/VTextAreaWithValidation.vue';
import VTextFieldWithValidation from '@/components/VTextFieldWithValidation.vue';
import VSelectWithValidation from '@/components/VSelectWithValidation.vue';
import VAutocompleteWithValidation from '@/components/VAutocompleteWithValidation.vue';
import { ValidationProvider } from 'vee-validate';

@Component({
  components: {
    VTextFieldWithValidation,
    VSelectWithValidation,
    VTextAreaWithValidation,
    VAutocompleteWithValidation,
  },
})
export default class EditTemplate extends Vue {
  public valid = true;
  public templateValue: string = '';
  public contractName: string = '';
  public serviceName: string = '';
  public senderName: string | null = '';
  public priority: string = '';
  public mnoBans: string[] = [];
  public tags: string[] = [];
  public contractsList: string[] = [];
  public servicesList: string[] = [];
  public sendersList: string[] = [];
  public prioritiesList: string[] = [];
  public mnosList: string[] = [];
  public commentary: string | null = '';
  public ignoreUserBans: boolean = false;
  public messageToParse: string = '';
  public messageParseResult: boolean | null = null;
  public priorities;
  public contracts;
  public services;
  public senders;
  public $refs!: {
    observer: InstanceType<typeof ValidationProvider>;
  };

  public tagsSearch: string = '';
  public tagsSelect: string[] = [];
  public tagsFetchDebounce: Function | null = null;

  public async mounted() {
    await dispatchGetTemplate(this.$store, Number(this.$router.currentRoute.params.id));
    await dispatchGetContracts(this.$store);
    await dispatchGetServices(this.$store);
    await dispatchGetSenders(this.$store);
    await dispatchGetPriorities(this.$store);
    await dispatchGetMNOs(this.$store);
    this.contracts = new Map<string, number>(
      readContracts(this.$store).map((item) => [item.name, item.id] as [string, number]),
    );
    this.priorities = new Map<string, number>(
      readPriorities(this.$store).map((item) => [item.name, item.id] as [string, number]),
    );
    for (const item of readMNOs(this.$store)) {
      this.mnosList.push(item.name);
    }
    this.contractsList = Array.from(this.contracts.keys());
    this.prioritiesList = Array.from(this.priorities.keys());
    this.reset();
  }

  @Watch('messageToParse')
  public updateMessageParseResult() {
    if (this.messageParseResult !== null) {
      this.messageParseResult = null;
    }
  }

  public reset() {
    this.$refs.observer.reset();
    if (this.template) {
      this.templateValue = this.template.template;
      this.contractName = this.template.contract_name;
      this.serviceName = this.template.service_name;
      this.senderName = this.template.sender_name;
      this.priority = this.template.priority;
      this.mnoBans = this.template.mno_bans;
      this.tags = this.template.tags.map((item) => item.text);
      this.commentary = this.template.commentary;
      this.ignoreUserBans = this.template.ignore_user_bans;
    }
  }

  public cancel() {
    this.$router.back();
  }

  public async parseMessage() {
    const result = await dispatchParseMessage(this.$store, {
      template: this.templateValue,
      message: this.messageToParse,
    });
    if (result) {
      this.messageParseResult = result.correct;
    } else {
      this.messageParseResult = null;
    }
  }

  public async submit() {
    if (await this.$refs.observer.validate()) {
      const updatedTemplate: ITemplateUpdate = {
        template: this.templateValue,
        contract_id: this.contracts.get(this.contractName),
        service: this.serviceName,
        sender: this.senderName || '',
        priority_id: this.priorities.get(this.priority),
        mno_bans: this.mnoBans,
        tags: this.tags,
        commentary: this.commentary,
        ignore_user_bans: this.ignoreUserBans,
      };
      const result = await dispatchUpdateTemplate(this.$store, { id: this.template!.id, template: updatedTemplate });
      if (result) {
        this.$router.push('/main/admin/templates');
      }
    }
  }

  public getContractName(template: ITemplate) {
    const contractsList = readContracts(this.$store);
    const contract = contractsList.find((t) => t.id == template.contract_id);
    return contract?.name ?? '';
  }

  get template() {
    const template: any = readOneTemplate(this.$store)(+this.$router.currentRoute.params.id);
    template.contract_name = this.getContractName(template);
    return template;
  }

  @Watch('tagsSearch')
  async tagsSearchChanged() {
    this.tagsFetchDebounce =
      this.tagsFetchDebounce ||
      _.debounce(() => {
        dispatchSuggestTags(this.$store, this.tagsSearch).then(
          (data) => (this.tagsSelect = data ? data.map((item) => item.text) : []),
        );
      }, 250);
    this.tagsFetchDebounce();
  }

  @Watch('contractName')
  contractNameChanged() {
    const contracts = readContracts(this.$store);
    const currentContract = contracts.find((contract) => contract.name == this.contractName);
    if (currentContract) {
      this.services = new Map<string, any>(
        currentContract.services.map((item: any) => [item.service, item] as [string, number]),
      );
      this.servicesList = Array.from(this.services.keys());
    }
  }

  @Watch('serviceName')
  contractServiceChanged(val: string) {
    const senders: any = this.services.get(val);
    this.sendersList = senders?.allowed_senders ?? [];
  }
}
